import { useContext } from "react";
import "./ProductsComponent.scss";
import ProductSmall from "./ProductSmall";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import { Cart, Percent, Tv } from "react-bootstrap-icons";
import { AuthContext } from "../../services/AuthContext";
import { GlobalFunctionsContext } from "../../services/GlobalFunctionsContext";
import { Button } from "react-bootstrap";
import ButtonAddToCart from "./ButtonAddToCart";

export default function ProductsComponent ({viewType, products, onVisible, onMessage}) {
  const { isAuthenticated } = useContext(AuthContext);
  const { convertStringToLink, formatCurrency } = useContext(GlobalFunctionsContext);
  const navigate = useNavigate();

  const hundleUpdateProduct = (id, c) => {
    const idx = products.findIndex(prod => prod.id === id)
    products[idx].inCart = c > 0
    products[idx].cantInCart = c
  }
  
  return (
    <>
      {viewType !== "list" && (
        <div className={viewType === "grid" ? "grid-view" : "list-view"}>
          {products &&
            products.map((item) => <ProductSmall key={`producto_${item.id}`} product={item} updateProduct={hundleUpdateProduct} onVisible={onVisible} onMessage={onMessage}/>)}
        </div>
      )}
      {viewType === "list" && (
        <div className="table-view">
          <Table>
            <thead>
              <tr>
                <th>Producto</th>
                <th>Código</th>
                <th>Venta</th>
                <th>Precio</th>
                {isAuthenticated ? <th></th> : null}
              </tr>
            </thead>
            <tbody>
              {products &&
                products.map((item, index) => {
                  let nombre = convertStringToLink(item.nombre)
                  return ( <tr key={`producto_${item.id}`} >
                    <th style={{
                              backgroundColor: index % 2 === 0 ? '#FAFAFA' : '#EBEBEB',
                            }}>
                      <div className="inner-table">
                        <img
                            loading="lazy"
                            src={item.preview}
                            alt={item.nombre}
                          />
                          <a href={item.webLink}>
                            <div className="highlights">
                            {item.en_tv > 0 ? <span className="en_tv"><Tv /> En Tv</span>: null}
                            {item.fecha_dif < 60 ? <span className="new">Novedad</span>: null}
                            {item.descuento > 0 ? <span className="promo"><Percent /> promo</span>: null}
                            </div>
                            
                            <div className="inner-title">
                              {item.nombre} 
                              {item.inCart ? <small>{item.cantInCart} en carrito</small> : null}
                            </div>
                          </a>
                      </div>
                    </th>
                    <th style={{
                              backgroundColor: index % 2 === 0 ? '#FAFAFA' : '#EBEBEB',
                            }}>{item.sku}</th>
                    <th className="unVenta" style={{
                              backgroundColor: index % 2 === 0 ? '#FAFAFA' : '#EBEBEB',
                            }}>{item.minimo_compra}</th>
                    <th style={{
                              backgroundColor: index % 2 === 0 ? '#FAFAFA' : '#EBEBEB',
                            }}>{isAuthenticated
                      ? <div className="price"><span>$</span>{formatCurrency(item.precio)}<span>+ iva</span></div>
                      : <>
                          <div className="btn-content">
                            <Button
                              variant="primary"
                              className="small"
                              onClick={()=>{navigate('/login')}}
                            >Inicia Sesión</Button>
                          </div>
                        </>
                      }
                    </th>
                    {isAuthenticated 
                      ? <>
                          <th style={{
                              backgroundColor: index % 2 === 0 ? '#FAFAFA' : '#EBEBEB',
                            }}>
                            <div className="btn-content">
                              {item.variedades === 0 
                                ? <ButtonAddToCart  product={item} small={true} updateProduct={hundleUpdateProduct} onVisible={onVisible} onMessage={onMessage} />
                                :  <Button
                                      variant="primary"
                                      className="small"
                                      onClick={()=>{navigate(`/producto/${item.id}-${nombre}`)}}
                                    >
                                      Agregar <Cart />
                                    </Button>
                              }
                            </div>
                          </th>
                        </>
                      : null
                    }
                    </tr>
                  )})
                }
            </tbody>
          </Table>
        </div>
      )}
    </>
  )
}
